const {relatedProducts} = window["@algolia/recommend-js"];
const recommend = window["@algolia/recommend"];

const sClient = algoliasearch("MB13IY345Y", "5a50c24f3e92ae83f808068a942a1f3b");
const idx = sClient.initIndex("shopify_products");

const recommendClient = recommend(
  "MB13IY345Y",
  "5a50c24f3e92ae83f808068a942a1f3b",
);
const indexName = "shopify_products";

function getShopifyProduct(handle) {
  // return new Promise(async function (resolve, reject) {
  let protocol = window.location.protocol;
  let currentDomain = window.location.hostname;

  if (currentDomain.includes("127.0.0.1")) {
    currentDomain = "127.0.0.1:9292";
  }

  const shopifyProductUrl = `${protocol}//${currentDomain}/products/${handle}.json`;
  // const shopifyAllProductsUrl = `${protocol}//${currentDomain}/products.json`;

  // console.log('All Products (json): ', shopifyAllProductsUrl);
  // console.log("Single Product (json): ", shopifyProductUrl);

  return fetch(shopifyProductUrl, {
    method: "GET",
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      var productData = data.product;
      return productData;
    });
}

// use the api to get the correc t object ID by passing the product ID
// const generateObjectID = () => {
//   const id = localStorage.getItem("queryID");

//   return new Promise((resolve, reject) => {
//     console.log("getting related products...");
//   });
// };

if ("clickedObjectID" in localStorage) {
  relatedProducts({
    container: "#relatedProducts",
    recommendClient,
    indexName,
    analytics: false,
    maxRecommendations: 6,
    objectIDs: [localStorage.getItem("clickedObjectID")],
    headerComponent(props) {
      const originalID = document
        .querySelector("#relatedProducts")
        .getAttribute("data-product-id");

      // return all product ids that are recommended by algolia
      let allIDS = props.recommendations.map((i) => {
        return i.id.toString();
      });

      // check that there is at least 1 recommendation, if there not then dont display the title
      // also check to see if algolia is recommending the same current product, if it is dont display the title
      if (props.recommendations.length <= 1 && allIDS.includes(originalID)) {
        document
          .querySelector("#related-products-subtitle")
          .classList.add("hidden");
      } else if (props.recommendations.length == 0) {
        document
          .querySelector("#related-products-subtitle")
          .classList.add("hidden");
      } else {
        document
          .querySelector("#related-products-subtitle")
          .classList.remove("hidden");
      }
    },
    view(props) {
      let container = document.querySelector("#mix-match-inject");

      props.items.map((item) => {
        container.innerHTML += props.itemComponent({item});
      });

      const cards = document.querySelectorAll(".product-mix-match__card");

      // console.log(cards.length)
      cards.forEach((item) => {
        const handle = item.dataset.handle;
        getShopifyProduct(item, handle);
      });
    },
    itemComponent({item, createElement}) {
      const originalID = document
        .querySelector("#relatedProducts")
        .getAttribute("data-product-id");

      // console.log(originalID);

      const hasMultiBuy = () => {
        let all = item.tags.toString();
        if (isOutOfStockHelper()) {
          return "";
        } else {
          if (all.includes("Item_pro_Buy")) {
            return `<div class="card-product__badge card-product__multiOffer">Multi Buy</div>`;
          } else {
            return ``;
          }
        }
      };

      const isNew = () => {
        let all = item.collections.toString();
        if (all.includes("new")) {
          return `<div class="card-product__badge card-product__newHighlight">New in</div>`;
        } else {
          return ``;
        }
      };

      const hasFlavour = () => {
        // console.log(data);
        if (item.named_tags.Profile) {
          if (typeof item.named_tags.Profile == "string") {
            return item.named_tags.Profile;
          }
        } else {
          return "";
        }
      };

      const isDisposable = () => {
        let all = item.collections.toString();
        if (all.includes("disposable-vape-kits")) {
          return true;
        } else {
          return false;
        }
      };

      const disposableCount = () => {
        let all = item.tags;
        let c = "";
        all.filter((t, i) => {
          if (t.includes("Profile_")) {
            c = t.replace("Profile_", "");
            return t.replace("Profile_", "");
          } else {
            return "";
          }
        });
        return c;
      };

      const isOutOfStockHelper = () => {
        if (
          item.variants_inventory_count == 0 &&
          !item.collections.includes("new")
        ) {
          return true;
        } else {
          return "";
        }
      };

      const isOutOfStock = () => {
        if (
          item.variants_inventory_count <= 0 &&
          !item.collections.includes("new")
        ) {
          return `<div class="card-product__oos">Out Of Stock</div>`;
        } else {
          return "";
        }
      };

      const getMultibuyOffer = () => {
        let tags = item.tags.toString();

        if (isOutOfStockHelper()) {
          return "";
        } else {
          if (item.collections) {
            if (tags.includes("Item_pro_Buy any 4 for £10")) {
              return `<a href="/collections/e-liquids/4-for-10"><div class="card-product__offerText">4 for £10</div></a>`;
            } else if (tags.includes("Item_pro_Buy any 5 for £20")) {
              return `<a href="/collections/e-liquids/5-for-20"><div class="card-product__offerText">5 for £20</div></a>`;
            } else if (tags.includes("Item_pro_Buy any 5 for £10")) {
              return `<a href="/collections/e-liquids/5-for-10"><div class="card-product__offerText">5 for £10</div></a>`;
            } else if (tags.includes("Item_pro_Buy any 3 for £10")) {
              return `<a href="/collections/e-liquids/3-for-10"><div class="card-product__offerText">3 for £10</div></a>`;
            } else if (tags.includes("Item_pro_Buy any 3 for £20")) {
              return `<a href="/collections/e-liquids/3-for-20"><div class="card-product__offerText">3 for £20</div></a>`;
            } else if (tags.includes("Item_pro_Buy any 2 for £25")) {
              return `<a href="/collections/100ml-e-liquids/2-for-25"><div class="card-product__offerText">2 for £25</div></a>`;
            } else if (tags.includes("Item_pro_Buy any 2 for £20")) {
              return `<a href="/collections/e-liquids/2-for-20"><div class="card-product__offerText">2 for £20</div></a>`;
            } else if (tags.includes("Item_pro1_Buy any 3 for £10")) {
              return `<a href="/collections/disposable-vape-kits/3-for-10"><div class="card-product__offerText">3 for £10</div></a>`;
            } else if (tags.includes("Item_pro1_Buy any 4 for £10")) {
              return `<a href="/collections/disposable-vape-kits/4-for-10"><div class="card-product__offerText">4 for £10</div></a>`;
            } else if (tags.includes("Item_pro1_Buy any 5 for £20")) {
              return `<a href="/collections/disposable-vape-kits/5-for-20"><div class="card-product__offerText">5 for £20</div></a>`;
            } else if (tags.includes("Item_pro1_Buy any 5 for £25")) {
              return `<a href="/collections/disposable-vape-kits/5-for-25"><div class="card-product__offerText">5 for £25</div></a>`;
            } else {
              return "";
            }
          }
        }
      };

      const emblaSlide = document.querySelectorAll(
        "#mix-match-inject .embla__slide",
      );

      let itemComponent = `
      <div class="embla__slide" data-slide-index="${emblaSlide.length}">
        <div id="Swiper-inspired-cart" class="product-mix-match__card swiper-slide js-product-mix-match-card" data-handle="${
          item.handle
        }"  data-type="inspired">
          <a class="card-product__wrapper-link" href="/products/${
            item.handle
          }"></a>
          <img class="product-mix-match__image" width="200" height="200" alt="${item.title}" loading="lazy" src="${
            item.image
          }" style="width: 200px"/>
          ${hasMultiBuy()}
          ${isNew()}
          ${getMultibuyOffer()}
          ${isOutOfStock()}
          <div style="margin-top: auto;" class="product-mix-match__wrapper">
            <h6 class="product-mix-match__card-title"">${item.title}</h6>
            ${
              isDisposable()
                ? `<div class="product-mix-match__flavour">${disposableCount()}</div>`
                : `<div class="product-mix-match__flavour">${hasFlavour()}</div>`
            }
            <div class="option-inject"></div>
            <span class="product-mix-match__price">£${item.price}</span>
            <a href="/products/${
              item.handle
            }" class="button button--primary button--primary--alternate">View</a>
          </div>
        </div>
      </div>
    `;

      return originalID == item.id ? "" : itemComponent;
      // return itemComponent
    },
  });
} else {
}

function getShopifyProduct(card, handle) {
  if (handle == undefined || null) {
    return;
  } else {
    // Compose json url
    const shopifyProductUrl = `/products/${handle}?view=quick-view`;

    axios
      .get(shopifyProductUrl)
      .then((response) => {
        // console.log(response.data);
        addVariantColors(card, response.data);
        return response;
      })
      .catch((error) => error);
  }
}

function addVariantColors(card, data) {
  const wrapper = card.querySelector(".option-inject");
  wrapper.innerHTML += data;
}
